import React from "react";
import { Col, Form, Row } from "@themesberg/react-bootstrap";
import { getStatusDisplayOptions, getStatusLegend, statusLogicOptions, STATUS_DISPLAY_KINDS } from "../utils/statusLights";
import StatusLightCircle from "./StatusLightCircle";

export default function StatusLightSettings({ mode, legacyStyle, alertActionStyle, onModeChange, onLegacyStyleChange, onAlertActionStyleChange, disabled, idPrefix = "" }) {
    const project = { statusLogicMode: mode };
    const isAlertAction = Number(mode) === 1;
    const selectedStyle = Number(isAlertAction ? alertActionStyle : legacyStyle);
    const showCirclePreview = selectedStyle === STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE || selectedStyle === STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE_WITH_TEXT;
    const modeId = `${idPrefix}statusLogicMode`;
    const styleId = `${idPrefix}statusLightStyle`;
    return (
        <Row>
            <Col md={6} className="mb-3">
                <Form.Group controlId={modeId}>
                    <Form.Label htmlFor={modeId}>燈號邏輯模式</Form.Label>
                    <Form.Select id={modeId} name="statusLogicMode" value={mode} onChange={e => onModeChange(Number(e.target.value))} disabled={disabled}>
                        {statusLogicOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                    </Form.Select>
                    <Form.Text className="text-muted">各專案獨立設定；未設定時使用原有模式。</Form.Text>
                </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
                <Form.Group controlId={styleId}>
                    <Form.Label htmlFor={styleId}>燈號顯示方式（{isAlertAction ? "黃警紅行" : "原有模式"}）</Form.Label>
                    <Form.Select id={styleId} value={isAlertAction ? alertActionStyle : legacyStyle}
                        onChange={e => (isAlertAction ? onAlertActionStyleChange : onLegacyStyleChange)(Number(e.target.value))}
                        disabled={disabled}>
                        {getStatusDisplayOptions(project).map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                    </Form.Select>
                    <Form.Text className="text-muted">兩種邏輯模式的樣式分別保存。</Form.Text>
                    {showCirclePreview && <div className="d-flex flex-wrap gap-3 mt-3" aria-label="燈號樣式預覽">
                        {getStatusLegend(project).map(light => <span key={light.color} className="d-inline-flex align-items-center gap-2">
                            <StatusLightCircle light={light} withText={selectedStyle === STATUS_DISPLAY_KINDS.GRADIENT_CIRCLE_WITH_TEXT} />
                            <small>{light.label}</small>
                        </span>)}
                    </div>}
                </Form.Group>
            </Col>
            <Col xs={12} className="mb-3">
                <div className="d-flex flex-wrap gap-3" aria-label="燈號模式說明">
                    {getStatusLegend(project).map(light => <span key={light.color}>
                        <span className="d-inline-block me-1 border" style={{ backgroundColor: light.background, width: "0.75rem", height: "0.75rem" }} aria-hidden="true" />
                        {light.colorName}燈：{light.label}
                    </span>)}
                </div>
                {isAlertAction && <Form.Text className="text-muted">警示 1、警示 2 亦顯示黃燈；超過行動值顯示紅燈。</Form.Text>}
            </Col>
        </Row>
    );
}
